import { styled } from "@mui/material"
import { Icon } from "../../../../muiStyled/DataDisplay/Icons"

export const ZoomIcon = styled(Icon)(() => ({
    fontSize: 22,
}))
